// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ErrorResponse } from '../models';
import { ValidationErrorResponse } from '../models';
import { Widget } from '../models';
import { WidgetCreate } from '../models';
import { WidgetEdit } from '../models';
import { WidgetsList } from '../models';
/**
 * WidgetApi - axios parameter creator
 * @export
 */
export const WidgetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">widget</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getOwner</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete widget.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling _delete.');
            }
            const localVarPath = `/v1/widget/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new widget.
         * @param {WidgetCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: WidgetCreate, options: any = {}): RequestArgs {
            const localVarPath = `/v1/widget`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">widget</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getOwner</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit widget.
         * @param {string} id 
         * @param {WidgetEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: WidgetEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling edit.');
            }
            const localVarPath = `/v1/widget/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">widget</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getOwner</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get widget.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling get.');
            }
            const localVarPath = `/v1/widget/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">owner</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get user widgets by user.
         * @param {string} ownerId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ownerId: string, offset?: number, limit?: number, options: any = {}): RequestArgs {
            // verify required parameter 'ownerId' is not null or undefined
            if (ownerId === null || ownerId === undefined) {
                throw new RequiredError('ownerId','Required parameter ownerId was null or undefined when calling list.');
            }
            const localVarPath = `/v1/widgets`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ownerId !== undefined) {
                localVarQueryParameter['ownerId'] = ownerId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WidgetApi - functional programming interface
 * @export
 */
export const WidgetApiFp = function(configuration?: Configuration) {
    return {
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">widget</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getOwner</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete widget.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = WidgetApiAxiosParamCreator(configuration)._delete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create new widget.
         * @param {WidgetCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: WidgetCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Widget> {
            const localVarAxiosArgs = WidgetApiAxiosParamCreator(configuration).create(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">widget</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getOwner</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit widget.
         * @param {string} id 
         * @param {WidgetEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: WidgetEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Widget> {
            const localVarAxiosArgs = WidgetApiAxiosParamCreator(configuration).edit(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">widget</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getOwner</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get widget.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Widget> {
            const localVarAxiosArgs = WidgetApiAxiosParamCreator(configuration).get(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">owner</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get user widgets by user.
         * @param {string} ownerId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ownerId: string, offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetsList> {
            const localVarAxiosArgs = WidgetApiAxiosParamCreator(configuration).list(ownerId, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * WidgetApi - factory interface
 * @export
 */
export const WidgetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">widget</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getOwner</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete widget.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any) {
            return WidgetApiFp(configuration)._delete(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Create new widget.
         * @param {WidgetCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: WidgetCreate, options?: any) {
            return WidgetApiFp(configuration).create(body, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">widget</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getOwner</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit widget.
         * @param {string} id 
         * @param {WidgetEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: WidgetEdit, options?: any) {
            return WidgetApiFp(configuration).edit(id, body, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">widget</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getOwner</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get widget.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any) {
            return WidgetApiFp(configuration).get(id, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">owner</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get user widgets by user.
         * @param {string} ownerId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ownerId: string, offset?: number, limit?: number, options?: any) {
            return WidgetApiFp(configuration).list(ownerId, offset, limit, options)(axios, basePath);
        },
    };
};

/**
 * WidgetApi - object-oriented interface
 * @export
 * @class WidgetApi
 * @extends {BaseAPI}
 */
export class WidgetApi extends BaseAPI {
    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">widget</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getOwner</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Delete widget.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetApi
     */
    public _delete(id: string, options?: any) {
        return WidgetApiFp(this.configuration)._delete(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Create new widget.
     * @param {WidgetCreate} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetApi
     */
    public create(body?: WidgetCreate, options?: any) {
        return WidgetApiFp(this.configuration).create(body, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">widget</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getOwner</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Edit widget.
     * @param {string} id 
     * @param {WidgetEdit} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetApi
     */
    public edit(id: string, body?: WidgetEdit, options?: any) {
        return WidgetApiFp(this.configuration).edit(id, body, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">widget</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getOwner</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Get widget.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetApi
     */
    public get(id: string, options?: any) {
        return WidgetApiFp(this.configuration).get(id, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">owner</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Get user widgets by user.
     * @param {string} ownerId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetApi
     */
    public list(ownerId: string, offset?: number, limit?: number, options?: any) {
        return WidgetApiFp(this.configuration).list(ownerId, offset, limit, options)(this.axios, this.basePath);
    }

}
